export default __webpack_public_path__ + "static/media/CNo.87-6.497bfacc.jpg";